import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import { DataTable } from "@ploy-ui/core";
import { FormattedDate } from "react-intl";
export const ProcessLog = ({ log, updateStatus, approved }) => {
    const [processLog, setProcessLog] = React.useState(log.map(x => {
        let p = {
            agreementNumber: x.agreementNumber,
            vendorName: x.vendorName,
            amount: x.upfrontAmount,
            user: x.userFullName,
            date: x.date,
            vendorId: x.vendorId,
            type: x.agreementType,
            message: ""
        };
        return p;
    }));
    const handleUpdateStatus = async (request, status) => {
        const response = await updateStatus(request);
        if (response && response.success) {
            let p = processLog.map(x => {
                if (x.agreementNumber === request.agreementNumber &&
                    x.type === request.type &&
                    x.date.getTime() === request.date.getTime()) {
                    x.message = `Avregningen ble merket som ${status}`;
                }
                return x;
            });
            setProcessLog(p);
        }
    };
    return (_jsx(_Fragment, { children: _jsx(DataTable, { options: {
                search: false,
                showTitle: false,
                paging: false,
                emptyRowsWhenPaging: false,
                toolbar: false,
                headerStyle: { padding: "6,9" }
            }, data: processLog, columns: [
                { title: "Forhandler", field: "vendorName" },
                { title: "Beløp", field: "amount", cellStyle: { padding: "6,9" } },
                { title: "Type", field: "type" },
                { title: "Avtalenummer", field: "agreementNumber" },
                { title: approved ? "Godkjent av" : "Sendt til", field: "user" },
                {
                    title: "Dato",
                    render: row => (_jsx(FormattedDate, { value: row.date, month: "long", year: "numeric" }))
                },
                {
                    title: "",
                    render: row => row.message ? (_jsx(Typography, { children: row.message })) : (_jsx(Grid, { container: true, children: _jsxs(Grid, { item: true, xs: 12, children: [_jsx(Box, { p: 0.5, style: { display: "inline-block" }, children: _jsx(Button, { color: "primary", variant: "contained", onClick: () => {
                                            const t = {
                                                agreementNumber: row.agreementNumber,
                                                amount: row.amount,
                                                date: row.date,
                                                vendorId: row.vendorId,
                                                newStatus: "Approved",
                                                type: row.type
                                            };
                                            handleUpdateStatus(t, "godkjent");
                                        }, children: "Godkjenn" }) }), _jsx(Box, { p: 0.5, style: { display: "inline-block" }, children: _jsx(Button, { color: "primary", variant: "contained", onClick: () => {
                                            const t = {
                                                agreementNumber: row.agreementNumber,
                                                amount: row.amount,
                                                date: row.date,
                                                vendorId: row.vendorId,
                                                newStatus: "Declined",
                                                type: row.type
                                            };
                                            handleUpdateStatus(t, "avslått");
                                        }, children: "Avsl\u00E5" }) })] }) })),
                    hidden: approved
                },
                {
                    title: "",
                    render: row => (_jsx(_Fragment, { children: row.message ? (_jsx(Typography, { children: row.message })) : (_jsx(Button, { color: "primary", variant: "contained", onClick: () => {
                                const t = {
                                    agreementNumber: row.agreementNumber,
                                    amount: row.amount,
                                    date: row.date,
                                    vendorId: row.vendorId,
                                    newStatus: "Paid",
                                    type: row.type
                                };
                                handleUpdateStatus(t, "utbetalt");
                            }, children: "Utbetalt" })) })),
                    hidden: !approved
                }
            ] }) }));
};
//# sourceMappingURL=ProcessLog.js.map